/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PublishsetCreateRequest } from '../types/PublishsetCreate';
import type { PublishsetCreateResponse } from '../types/PublishsetCreate';

export type PublishsetsCreateRequest = PublishsetCreateRequest;
export type PublishsetsCreateResponse = PublishsetCreateResponse;

export type PublishsetsCreateQuery = {};

/**
 * POST /dmx-server/publishsets/
 *
 * ```yaml
 * operationId: publishsets_create
 * description: |-
 *   {
 *   "formats": ["/dmx-server/formats/6/",
 *       "/dmx-server/formats/7/"
 *       ],
 *   "name": "jmeno",
 *   "description": "popis",
 *   "needs_approval": true,
 *   "state": "PREPARING",
 *   "tags": [
 *       "/dmx-server/publishset_tags/2/",
 *       "/dmx-server/publishset_tags/3/"
 *   ],
 *   "approver_roles": ["VYDEJ_MANAGER"],
 *   "publishset_datasets": [
 *           {"dataset": "/dmx-server/datasets/1478/",
 *            "condition": "where something!=something else",
 *            "fields": ["PORIZ_ID", "POZN_OST"]},
 *           {"dataset": "/dmx-server/datasets/1475/"}
 *
 *       ]
 *   }
 * tags:
 *   - publishsets
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PublishsetCreate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PublishsetCreate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PublishsetCreate'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PublishsetCreate'
 *     description: ''
 * ```
 */
export const publishsetsCreateOperation = (rest?: PublishsetsCreateQuery | null) =>
  ({
    method: 'POST',
    path: `/dmx-server/publishsets/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/publishsets/' };
  };

/**
 * POST /dmx-server/publishsets/
 *
 * ```yaml
 * operationId: publishsets_create
 * description: |-
 *   {
 *   "formats": ["/dmx-server/formats/6/",
 *       "/dmx-server/formats/7/"
 *       ],
 *   "name": "jmeno",
 *   "description": "popis",
 *   "needs_approval": true,
 *   "state": "PREPARING",
 *   "tags": [
 *       "/dmx-server/publishset_tags/2/",
 *       "/dmx-server/publishset_tags/3/"
 *   ],
 *   "approver_roles": ["VYDEJ_MANAGER"],
 *   "publishset_datasets": [
 *           {"dataset": "/dmx-server/datasets/1478/",
 *            "condition": "where something!=something else",
 *            "fields": ["PORIZ_ID", "POZN_OST"]},
 *           {"dataset": "/dmx-server/datasets/1475/"}
 *
 *       ]
 *   }
 * tags:
 *   - publishsets
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PublishsetCreate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PublishsetCreate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PublishsetCreate'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PublishsetCreate'
 *     description: ''
 * ```
 */
export const publishsetsCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: PublishsetsCreateQuery;
  request: PublishsetCreateRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PublishsetCreateResponse>> => {
  const operation = publishsetsCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
